import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Container, Row } from 'reactstrap';
import moment from 'moment';

// Services
import { getSessionCookie } from '../../../../services/session';

// Components
import Header from '../../../../components/Headers/Header';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Contatnts
import { relatorioStyles } from '../../../../constants/relatorioStyles';

function RelatorioProdutividadeAnalitico({ handleReturn, cabecalho, relatorio }) {
    const session = getSessionCookie();

    const refImprimir = useRef();

    const [dadosReletorio, setDadosRelatorio] = useState([])

    // Função acionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório Produtividade Analítico",
        pageStyle: relatorioStyles,
    });

    useEffect(() => {
        relatorio = relatorio?.map(value => {
            if (value.relatorioProdutividadeAnaliticaDestinacoes.length > 0) {
                value.relatorioProdutividadeAnaliticaDestinacoes.unshift({
                    veiculo: "",
                    dataHoraEntrada: "ENTRADA",
                    dataHoraSaida: "SAÍDA",
                    pesoBruto: "PBT",
                    tara: "TARA",
                    pesoLiquido: "LIQUIDO",
                });
            }
            return value;
        });

        setDadosRelatorio(relatorio);
    }, []);


    return (
        <>
            <Header />
            <Row>
                <Container className="mt--9" fluid>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Voltar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                        </Button>
                    </div>
                    <div className="card shadow">
                        <div className='card-body print-padding print' ref={refImprimir}>
                            <div className='row header'>
                                <div className='col-sm-12 col-lg-12 text-center print-image' style={{ display: "none" }}>
                                    <img
                                        src={require("assets/img/brand/logo.png")}
                                        alt="imagem do sistema"
                                        width={150}
                                    />
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <h2>Relatório Produtividade Analítico</h2>
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <span className='font-weight-bold'>Modalidade de Serviço: </span> <span>{cabecalho?.modalidade}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Início:</span> <span>{cabecalho?.dataInicio && moment(cabecalho?.dataInicio).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Fim:</span> <span>{cabecalho?.dataFim && moment(cabecalho?.dataFim).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Divisão Administrativa:</span> <span>{cabecalho?.divisaoAdministrativa}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Plano de Trabalho:</span> <span>{cabecalho?.planoTrabalho}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className={"mt-3 col-sm-12 col-lg-12"}>
                                    <div className='table-responsive'>
                                        <table className='table-bordered tabela-relatorio  w-100' >
                                            <thead style={{ background: "#BEBEBE" }}>
                                                <tr>
                                                    <th>OPERADOR</th>
                                                    <th>RECURSO</th>
                                                    <th>INÍCIO DA EXECUÇÃO</th>
                                                    <th>FIM DA EXECUÇÃO</th>
                                                    <th>TEMPO DE EXECUÇÃO <br /> DA ORDEM</th>
                                                    <th>TEMPO DE ATUAÇÃO <br /> NOS LOCAIS DE EXECUÇÃO</th>
                                                    <th>TOTAL <br /> PERCORRIDO</th>
                                                    <th>PESAGEM LÍQUIDA <br /> TOTAL (KG)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dadosReletorio?.map((value, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr style={{ background: "#e9e2e2" }}>
                                                            <td className="text-center">{value.operador?.toUpperCase()}</td>
                                                            <td className="text-center">{value.veiculo?.toUpperCase()}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoInicio}</td>
                                                            <td className="text-center">{value.dataHoraExecucaoFim}</td>
                                                            <td className="text-center">{value.tempoExecucaoOrdemColeta}</td>
                                                            <td className="text-center">{value.tempoMedioExecucaoLocais}</td>
                                                            <td className="text-center">{value.quilometragemPercorrida}</td>
                                                            <td className="text-center align-middle table-footer-row" rowSpan={value.relatorioProdutividadeAnaliticaDestinacoes.length + 2}>
                                                                {value.totalLiquido?.replace("R$", "")}
                                                            </td>
                                                        </tr>

                                                        {/* Linha DESTINAÇÕES */}
                                                        {value.relatorioProdutividadeAnaliticaDestinacoes.length > 0 && (
                                                            <tr>
                                                                <td className="text-center align-middle" rowSpan={value.relatorioProdutividadeAnaliticaDestinacoes.length + 1}>
                                                                    DESCARREGAMENTO
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {/* Linhas secundárias */}
                                                        {value.relatorioProdutividadeAnaliticaDestinacoes.map((destinacao, subIndex) => (
                                                            <tr key={subIndex}>
                                                                <td className="text-center">{subIndex === 0 ? null : destinacao.veiculo?.toUpperCase()}</td>
                                                                <td className="text-center">{destinacao.dataHoraEntrada}</td>
                                                                <td className="text-center">{destinacao.dataHoraSaida}</td>
                                                                <td className="text-center">{destinacao.pesoBruto}</td>
                                                                <td className="text-center">{destinacao.tara}</td>
                                                                <td className="text-center">{destinacao.pesoLiquido}</td>
                                                            </tr>
                                                        ))}

                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='print-footer w-100 mt-2' style={{ display: "none" }}>
                                    <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Row>
        </>
    );
}

export default RelatorioProdutividadeAnalitico;
